<template>
    <v-app id="userLayout">
        <v-navigation-drawer
                class="notranslate"
                v-model="drawer"
                :clipped="$vuetify.breakpoint.lgAndUp"
                fixed
                app
        >
            <v-list>
                <v-list-tile to="/home/">
                    <v-list-tile-action>
                        <v-icon class="notranslate">home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Главная
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>

                <v-list-tile color="indigo">
                    <v-list-tile-action>
                        <v-avatar size="25">
                            <v-icon class="notranslate" v-if="!$store.state.user.ava" color="indigo">account_circle</v-icon>
                            <img v-else :src="$store.state.user.ava">
                        </v-avatar>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            {{$store.state.user.name}}
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action title="Обновить все данные">
                        <v-btn icon @click="reloadProfile">
                            <v-icon class="notranslate">refresh</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>

                <v-list-tile to="/home/profile">
                    <v-list-tile-action>
                        <v-icon class="notranslate"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Основные данные
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-icon class="notranslate" v-if="$store.state.user.checks.profile" color="green">check</v-icon>
                        <v-icon class="notranslate" v-else color="grey">priority_high</v-icon>
                    </v-list-tile-action>
                </v-list-tile>

                <v-list-tile to="/home/agenda">
                    <v-list-tile-action>
                        <v-icon class="notranslate"></v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Базовая анкета
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                        <v-icon class="notranslate" v-if="$store.state.user.checks.agenda" color="green">check</v-icon>
                        <v-icon class="notranslate" v-else color="grey">priority_high</v-icon>
                    </v-list-tile-action>
                </v-list-tile>


                <v-divider></v-divider>

                <v-list-tile>
                    <v-list-tile-action>
                        <v-icon class="notranslate">library_books</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Тесты
                        </v-list-tile-title>
                    </v-list-tile-content>
                    <v-list-tile-action v-if="$store.state.user.name">
                        <v-btn icon to="/home/tests/reg">
                            <v-icon class="notranslate" color="grey" title="Зарегистрировать новый тест">add_circle</v-icon>
                        </v-btn>
                    </v-list-tile-action>
                </v-list-tile>

                <template v-for="testcode in this.$store.state.user.testcodes">

                    <v-list-group value="true">
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        Тест - {{ testcode.id }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>

                        <template v-if="allChecksPassed">

                            <v-list-tile v-if="true" :to="'/home/tests/download/'+testcode.id">
                                <v-list-tile-action>
                                    <v-icon class="notranslate">cloud_download</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Скачать файлы с <br>результатами исследования
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-divider v-if="false"></v-divider>

                            <v-list-tile>
                                <v-list-tile-action>
                                    <v-icon class="notranslate">assessment</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        Отчеты
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <template v-for="report in testcode.reports">
                                <v-list-tile v-if="report.isReady" :to="'/home/report/get/'+report._id+'/ru/'">
                                    <v-list-tile-action>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{report.title || report.reportId}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action v-if="report.isReady">
                                        <v-icon color="green">check</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                                <v-list-tile v-else title="Отчет еще не готов">
                                    <v-list-tile-action>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{report.title || report.reportId}}
                                        </v-list-tile-title>
                                    </v-list-tile-content>
                                    <v-list-tile-action>
                                        <v-icon class="notranslate" color="grey">rotate_right</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>
                            </template>
                        </template>
                        <template v-else>
                            <v-list-tile class="pb-4 pt-3">
                                Для просмотра результатов теста, пожалуйста, завершите заполнение анкет
                            </v-list-tile>
                        </template>
                    </v-list-group>

                </template>


                <template v-for="item in items">
                    <v-layout v-if="item.heading" :key="item.heading" row align-center>
                        <v-flex xs6>
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                            <a href="#!" class="body-2 black--text">EDIT</a>
                        </v-flex>
                    </v-layout>
                    <v-list-group
                            v-else-if="item.children"
                            :key="item.text"
                            v-model="item.model"
                            :prepend-icon="item.model ? item.icon : item['icon-alt']"
                            append-icon=""
                            class="notranslate"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ item.text }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.to"
                                     @click="item.click | (()=>{})">
                            <v-list-tile-action>
                                <v-icon>{{ child.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ child.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list-group>
                    <template v-else>
                        <v-list-tile v-if="!item.level || $store.state.user.level>=item.level" :key="item.text" :to="item.to" @click="item.click | (()=>{})">
                            <v-list-tile-action>
                                <v-icon class="notranslate">{{ item.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ item.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </template>
                </template>

            </v-list>
        </v-navigation-drawer>
        <v-toolbar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                color="blue darken-3"
                dark
                app
                fixed
        >
            <v-toolbar-side-icon class="notranslate" @click.stop="drawer = !drawer" v-if="true"></v-toolbar-side-icon>
            <v-toolbar-title>
                <v-avatar size="32px" @click.stop="drawer = !drawer">
                    <img src="/media/logo-mobile.png" alt="Zenome">
                </v-avatar>
                <span class="hidden-sm-and-down notranslate">&nbsp; My Zenome</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat class="" to="/home/profile">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{$store.state.user.name}}</span>
                <v-avatar size="25" class="ml-3">
                    <v-icon class="notranslate" v-if="!$store.state.user.ava">account_circle</v-icon>
                    <img v-else :src="$store.state.user.ava">
                </v-avatar>

            </v-btn>
            <v-btn icon v-if="false" @click="testAuth">
                <v-icon class="notranslate">notifications</v-icon>
            </v-btn>
            <v-btn icon @click="authLogout">
                <v-icon class="notranslate">exit_to_app</v-icon>
            </v-btn>
        </v-toolbar>
        <v-content style="background: #fff">
            <router-view/>
        </v-content>
    </v-app>
</template>

<script>
    export default {
        name: "MainLayout",
        methods: {
            reloadProfile: function () {
                var this_ = this;
                this.$store.dispatch('loadProfile', {}).then(function (response) {
                    this_.response = response
                })
            },
            serverReport: function () {
                this.$http.get('/report', {data: {}}).then(function (response) {
                    // eslint-disable-next-line
                    console.log(response);
                });
            },
            authLogout: function () {
                var this_ = this;
                this.$store.dispatch('logout', {}).then(function () {
                    this_.response = null
                    this_.$router.push('/user/login')
                })
            }
        },
        computed: {
            allChecksPassed: function () {

                return this.$store.state.user.checks.agenda & this.$store.state.user.checks.profile
            },
        },
        data: () => ({
            dialog: false,
            drawer: null,
            items2: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Отчеты',
                    model: true,
                    value: true,
                    children: [
                        //{icon: 'assessment', text: 'Тестовый отчет', to: "/home/testReport"},
                        {icon: 'assessment', text: 'Серверный отчет RU', to: "/home/serverReport:ru"},
                        {icon: 'assessment', text: 'Серверный отчет EN', to: "/home/serverReport:en"},
                        {text: 'Новый отчет'},
                        {text: 'История'}
                    ]
                },
                {icon: 'settings', text: 'Settings'},
                {icon: 'chat_bubble', text: 'Send feedback'},

            ],
            items3: [
                {icon: 'help', text: 'Help', to: "/home/help"},
                {icon: 'launch', text: 'Admin', to: "/admin", level: 3},
            ],
            items: [
                {icon: 'launch', text: 'Admin', to: "/admin", level: 3}
            ]
        }),
        props: {
            source: String
        }


    }
</script>

<style scoped>

</style>